import { render, staticRenderFns } from "./MyVehicle.vue?vue&type=template&id=892b3070&scoped=true"
import script from "./MyVehicle.vue?vue&type=script&lang=js"
export * from "./MyVehicle.vue?vue&type=script&lang=js"
import style0 from "./MyVehicle.vue?vue&type=style&index=0&id=892b3070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b3070",
  null
  
)

export default component.exports